<template></template>

<script>
  import 'jquery-validation'
  
  export default {
    name: 'RegisterInterestArea',
    mounted () {
      const $form = $('.form')
      const sciences = $('#science_id')
      const disciplines = $('#discipline_id')
      const subdisciplines = $('#subdiscipline_id')
      let scienceId = sciences.val()
      let disciplineId = disciplines.val()
      let subdisciplineId = subdisciplines.val()

      /**
       * Init Select2 for sciences
       */
      sciences.select2({
        language: {
          noResults: function () {
            return 'Aún no ha ingresado ningún valor'
          },
        },
      })

      sciences.on('select2:selecting', function(e) {
        disciplines.val('').trigger('change');
        subdisciplines.val('').trigger('change');
        subdisciplines.parent().hide('fast')
        disciplines.parent().show('fast')
      })

      sciences.on('change', function() {
        scienceId = $(this).val()
      })

      if (sciences.val()) {
        disciplines.parent().show()
      }

      /**
       * Init Select2 for disciplines
       */
      disciplines.select2({
        placeholder: 'Seleccione una opción',
        language: 'es',
        ajax: {
          url: '/api/disciplines',
          dataType: 'json',
          headers: {
            'Authorization': `Bearer ${window.access_token}`,
          },
          data (params) {
            return {
              q: params.term,
              page: params.page || 1,
              science: scienceId,
            }
          },
          processResults (data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      disciplines.on('select2:selecting', function(e) {
        subdisciplines.val('').trigger('change');
        subdisciplines.parent().show('fast')

        disciplineId = disciplines.val()
      })

      disciplines.on('change', function() {
        disciplineId = $(this).val()
      })

      if (disciplines.val()) {
        subdisciplines.parent().show()
      }

      /**
       * Init Select2 for subdisciplines
       */
      subdisciplines.select2({
        placeholder: 'Seleccione una opción',
        language: 'es',
        ajax: {
          url: '/api/subdisciplines',
          dataType: 'json',
          headers: {
            'Authorization': `Bearer ${window.access_token}`,
          },
          data (params) {
            return {
              q: params.term,
              page: params.page || 1,
              discipline: disciplineId,
            }
          },
          processResults (data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })
          
      /**
       * Init JQuery validation
       */
      $(() => {
        $('.form').validate({
          ignore: [],
          highlight: function (element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function (element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function (label, element) {
            if (element.hasClass('select2-input')) {
              label.insertAfter(element.siblings('span.select2'))
            }
            else {
              label.insertAfter(element)
            }
            
            label.addClass('invalid-feedback')
          },
          rules: {
            science_id: {
              required: true,
            },
            discipline_id: {
              required: true,
            },
            subdiscipline_id: {
              required: true, // TODO: Change to true.
            },
          },
          messages: {
            science_id: {
              required: 'Este campo es requerido.',
            },
            discipline_id: {
              required: 'Este campo es requerido.',
            },
            subdiscipline_id: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler (form) {
            $('#btn-save, #btn-cancel').prop('disabled', true)
            $('#btn-save').find('.spinner-border').removeClass('d-none')
            
            form.submit()
          },
        })
        
        $form.removeClass('invisible')

        $('#btn-cancel').on('click', (e) => {
          e.preventDefault()

          history.back()
        })
      })
    },
  }
</script>
